import { AbstractControl, ValidatorFn } from '@angular/forms';
import { isNil, Nillable } from '@web/utils';
import { AdminProductCharacteristics } from '../models/admin-product-details-form';
import { ValidationError, ValidationErrorParam } from '@web/shared/ui';

export class AdminProductCharacteristicsValidator {
  public static min(count: number): ValidatorFn {
    return (
      control: AbstractControl<Nillable<AdminProductCharacteristics>>,
    ) => {
      const { value } = control;

      if (!isNil(value)) {
        if (value?.items.length >= count) {
          return null;
        }
      }

      return {
        [ValidationError.Custom]: {
          [ValidationErrorParam.Message]: `Produkt powinien zawierać co najmniej ${count} charakterystyk.`,
        },
      };
    };
  }
}
